import { useState } from "react";

export default function CarInspectionSection({ title, color, photos }: { title: string; color: string; photos: { label: string; url: string }[] }) {
  const [viewIdx, setViewIdx] = useState<number | null>(null);
  return (
    <div className="mx-4 bg-white rounded-2xl p-4">
      <div className="flex items-center gap-2 mb-3">
        <i className="ri-camera-line" style={{ color, fontSize: 16 }} />
        <span className="text-sm font-bold text-gray-900">{title}</span>
        <span className="text-xs text-gray-400 ml-auto">司机已上传</span>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {photos.map((ph, i) => (
          <button key={i} onClick={() => setViewIdx(i)} className="relative rounded-xl overflow-hidden cursor-pointer" style={{ height: 88 }}>
            <img src={ph.url} alt={ph.label} className="w-full h-full object-cover" />
            <div className="absolute bottom-0 left-0 right-0 text-center py-1 text-white" style={{ background: "rgba(0,0,0,0.5)", fontSize: 10 }}>{ph.label}</div>
          </button>
        ))}
      </div>
      {viewIdx !== null && (
        <div className="fixed inset-0 z-50 flex items-center justify-center" style={{ background: "rgba(0,0,0,0.92)" }} onClick={() => setViewIdx(null)}>
          <div className="w-full max-w-sm px-4 text-center">
            <img src={photos[viewIdx].url} alt="" className="w-full rounded-2xl mb-3" />
            <div className="text-white text-sm">{photos[viewIdx].label}</div>
            <div className="flex justify-center gap-2 mt-3">
              {photos.map((_, i) => (
                <button key={i} onClick={e => { e.stopPropagation(); setViewIdx(i); }} className="rounded-full cursor-pointer" style={{ width: i === viewIdx ? 18 : 6, height: 6, background: i === viewIdx ? "#fff" : "rgba(255,255,255,0.35)" }} />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
